import React from 'react';

import { ActivityView } from '../common/ActivityView';

export function DefaultActivity() {
  return <ActivityView />;
}
